import { getStoryblokCacheVersion, fetchRedirectStories } from '@nuxt-monorepo/ui/utils/seo';
import { checkEarlyRedirect, checkFetchedRedirect } from '~/utils/seo';

export default defineNuxtRouteMiddleware(async (to: any, from: any) => {
    if (import.meta.client) return;

    // Check if the current route is a redirect
    const earlyRedirect = checkEarlyRedirect(to.path, to.query);
    if (earlyRedirect.type === 'skip') return;
    if (earlyRedirect.type === 'redirect') {
        return navigateTo(earlyRedirect.target, {
            external: true,
            redirectCode: earlyRedirect.statusCode,
        });
    }

    const queryParams = new URLSearchParams(from.query);
    const queryString = queryParams.toString() ? `?${queryParams}` : '';

    const cvResponse = await getStoryblokCacheVersion();
    const cv = cvResponse.space.version;

    const toUrl: string = to.path.endsWith('/') ? to.path.slice(0, to.path.length - 1) : to.path;
    const stories = await fetchRedirectStories({
        cv,
        filterQuery: { source_url: toUrl },
    });

    const redirect = checkFetchedRedirect(toUrl, stories, queryString);

    if (redirect.type === 'redirect') {
        return navigateTo(redirect.target, {
            external: true,
            redirectCode: redirect.statusCode,
        });
    }

    return;
});
